export function getBaseballTilesData({ videoAllData }) {
  const { handspeed, stride } = videoAllData || {};
  return [
    {
      key: "handSpeed",
      title: "Hand Speed",
      value: handspeed,
      unit: "mph",
      color: "blue",
    },
    {
      key: "strideLength",
      title: "Stride Length",
      value: stride,
      unit: "inches",
      color: "green",
    },
  ];
}

export async function handleDownloadJsonUrl({ clickedBtnData, fileid }) {
  // if (clickedBtnData.key === "threedIcon") return;
  const link = document.createElement("a");
  const funtionToDownloadUrl = clickedBtnData?.functionForApiCall;
  link.download = "file.json"; // Adjust the filename here if needed
  if (clickedBtnData.key === "videoIcon") {
    link.download = "file.mp4";
  }

  try {
    const res = await funtionToDownloadUrl({
      params: {
        fileid,
      },
    });

    link.href = res;
    // Simulate a click on the link to trigger the download
    link.click();
  } catch (error) {
    console.error("Error:", error);
  }
}

export function isDrawingActive({ key, tracerBtns }) {
  const isKeyActive = tracerBtns?.find((item) => item.key === key).active;
  return isKeyActive;
}

export function getHandSpeedGraphData(data, graphTimeValues) {
  if (!data) return;
  return {
    graphData: {
      labels: graphTimeValues,
      datasets: [
        {
          label: "Hand Speed",
          data: data,
          backgroundColor: "#19AE65",
          borderColor: " #19AE65",
        },
      ],
    },
  };
}
export function calculateBaseballGraphTimeValues({
  positions,
  timeStamps,
  firstPositionKey,
  lastPositionKey,
}) {
  let slicedTimestamps = [];
  let adjustedTimeStamps = [];

  if (timeStamps) {
    slicedTimestamps = getSlicedBaseballTimestamps(
      timeStamps,
      positions[firstPositionKey],
      positions[lastPositionKey]
    );

    if (slicedTimestamps.length > 0) {
      const firstValue = slicedTimestamps[0];
      adjustedTimeStamps = slicedTimestamps.map((value) => parseFloat(value));
    }
  }
  return adjustedTimeStamps;
}

export function getSlicedBaseballTimestamps(
  timestamps,
  startPosition,
  endPosition
) {
  if (startPosition < 0) startPosition = 0;
  if (endPosition >= timestamps.length) endPosition = timestamps.length - 1;

  // Slice the timestamps array based on startPosition and endPosition
  const slicedTimestamps = timestamps.slice(startPosition, endPosition + 1);

  return slicedTimestamps;
}
export function getBseballPvalueIndexes(positions, pValue) {
  const indexes = {};

  for (const key in positions) {
    indexes[key] = positions[key] - pValue;
  }

  return indexes;
}
